<script>
import Cookies from "js-cookie";
import {notificationMethods, saleMethods} from "@/state/helpers";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import appConfig from "@/app.config";

export default {
  page: {
    title: "Advisors",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      currentUser: JSON.parse(Cookies.get('user')),
      advisors: [],
      title: "Satışlar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Satışlar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      addForm: {},
      editForm: {},
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 5,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "orderDate",
          label: "Tarih",
          sortable: true
        },
        {
          key: "customer.name",
          label: 'Satın Alan',
          sortable: true,
        },
        {
          key: "ip",
          label: 'IP Adresi',
          sortable: false,
        },
        {
          key: "details",
          label: 'Detay',
          sortable: false,
        },
        {
          key: "discount",
          label: 'İndirim',
          sortable: false,
        },
        {
          key: "amount",
          label: 'Sepet Toplamı',
          sortable: true,
        },
        {
          key: "payment_amount",
          label: 'Ödenen Tutar',
          sortable: true,
        },
        {
          key: "status",
          label: 'Durum',
          sortable: true,
        },
      ],
      imgLoading: false,
      editImgLoading: false,
      pageInput: 1
    };
  },
  validations: {
    addForm: {},
    editForm: {},
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getSales(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getSales();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getSales();
  },
  methods: {
    ...saleMethods,
    ...notificationMethods,
    doSearch() {
      if (this.page === 1) {
        this.getSales(this.page);
      } else {
        this.page = 1;
      }
    },
    getSales(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchSales({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.data.total;
        //todo: res.docs.map olacak
        this.items = res.data.docs;
        this.itemsLoaded = true;
      })
    },
    moneyFormat(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
      }).format(value);
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(orderDate)="data">
                    {{ data.item.orderDate | formatDate }}
                  </template>

                  <template v-slot:cell(details)="data">
                    <ul>
                      <li v-for="course in data.item.details" :key="course.id">{{ course.course.name }}</li>
                    </ul>
                  </template>
                  <template v-slot:cell(discount)="data">
                    %{{ data.item.discount }}
                  </template>
                  <template v-slot:cell(amount)="data">
                    {{ moneyFormat(data?.item?.amount) }}
                  </template>
                  <template v-slot:cell(payment_amount)="data">
                    {{ moneyFormat(data?.item?.payment_amount / 100) }}
                  </template>
                  <template v-slot:cell(status)="data">
                     <span class="badge badge-pill font-size-14"
                           :class="{ 'badge-soft-success': data.item.status, 'badge-soft-danger': !data.item.status }">
                        <span>{{ data.item.status ? 'Başarılı' : 'Başarısız' }}</span>
                      </span>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
